import gql from "graphql-tag";

export const updateWorkspace = gql`
  mutation UpdateWorkspace($id: ID!, $data: WorkspaceUpdateInput!) {
    updateWorkspace(data: $data, where: { id: $id }) {
      id
    }
  }
`;
